import { render } from "./App.vue?vue&type=template&id=b01a605c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b01a605c&lang=css"

import exportComponent from "/builds/tel/jcr/ft_import_tool/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__